import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import { ENDPOINTS } from '../../constants/endpoints';
import westozLogo from "../../assets/img/westozlogo.jpg";
export function Header(props) {
    

    useEffect(() => {

    }, []);

    const setIsDemoModalOpen = () => {
        document.getElementById("book-demo").click();
    }

    return (

        <div className="fixed-top bg-header shadow container mt-2 rounded-pill">
            <header className="p-2 text-dark">
                <div className="p-0 p-sm-auto">
                    <div className="d-flex align-items-center justify-content-between">

                        <a href="/" className={"fw-bold navbar-brand d-flex align-items-center text-darrk text-decoration-none"}>
                            <img alt="West Oz Transport" src={westozLogo} className="westozlogo" />
                        </a>

                        <div className="d-flex">
                            <div className={"text-end me-2"}>
                                <button
                                    onClick={() => setIsDemoModalOpen()}
                                    className="btn color-gradient btn-lg fw-bold px-4"
                                >
                                    Book Free Demo &rarr;
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            </header>

            
        </div >
    );
}